// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "team-module--base-text-alt--global--88a76";
export var baseTextGlobal = "team-module--base-text--global--8fc6a";
export var blockSpacing100 = "team-module--block-spacing-100--2d5bd";
export var blockSpacing50 = "team-module--block-spacing-50--10dd2";
export var blockVPadding100 = "team-module--block-v-padding-100--4e1a9";
export var blockVPadding50 = "team-module--block-v-padding-50--85b2b";
export var captionTextGlobal = "team-module--caption-text--global--b4569";
export var cmsRenderedContentGlobal = "team-module--cms-rendered-content--global--64cd6";
export var contactOptionsContainer = "team-module--contactOptionsContainer--3d5f3";
export var defaultHSpacingGlobal = "team-module--default-h-spacing--global--0f2ea";
export var fadeInAnimation = "team-module--fadeInAnimation--64fea";
export var fadeInOnLoadGlobal = "team-module--fade-in-on-load--global--9a26e";
export var fullHeightGlobal = "team-module--full-height--global--227f9";
export var fullHeightOmittingNavGlobal = "team-module--full-height-omitting-nav--global--fce7a";
export var heading = "team-module--heading--87d70";
export var headingTextGlobal = "team-module--heading-text--global--63f69";
export var imageContainer = "team-module--imageContainer--f764c";
export var ingressTextGlobal = "team-module--ingress-text--global--ef8e0";
export var linkColorChangeTransitionGlobal = "team-module--link-color-change-transition--global--a2e8c";
export var mailIcon = "team-module--mailIcon--d1664";
export var memberContainer = "team-module--memberContainer--8a28f";
export var memberWrapper = "team-module--memberWrapper--85f94";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "team-module--page-heading-text--global--39ac0";
export var paragraphTextGlobal = "team-module--paragraph-text--global--16f49";
export var subheadingTextGlobal = "team-module--subheading-text--global--13351";
export var teamContainer = "team-module--teamContainer--a9933";